import React from 'react';
import styled from 'styled-components';
import { Container, TitleSet, colors, AnimateIn, media, InternalLink } from '../../ui-components';
import renderRichText from '../../utils/render-rich-text';
import fallbackImage from '../../assets/home-page/meet-us.png';

const renderOurImpactTitleSection = props => {
  const { label, title, bodyRichJSON, bodyString } = props;
  return (
    <TitleSet 
      label={label || 'Our Impact'} 
      title={title} 
      bodyText={bodyString ? bodyString : bodyRichJSON && renderRichText(bodyRichJSON)} />
  );
};

/**
 * @component renderContentCards
 *
 * @param {array} cards
 *
 * @returns {JSX}
 */
const renderContentCards = cards => {
  const contentCards = cards.map(card => {
    const { pointOfViewTitle, ctaText, ctaUrl, pointOfViewBody, bodyString } = card;
    const heroImage = card?.pointOfViewImage?.gatsbyImageData?.images?.fallback?.src;

    return (
      <ContentWrapper>
        <ContentImage src={heroImage || fallbackImage} alt={pointOfViewTitle} />
        <TextWrapper>
          <TitleSet alignLeft headingLevel={3} title={pointOfViewTitle} bodyText={bodyString ? bodyString : renderRichText(pointOfViewBody)} />
          <ReadMoreLink to={`/${ctaUrl}`} withArrow hoverUnderline>
            {ctaText || 'Read On'}
          </ReadMoreLink>
        </TextWrapper>
      </ContentWrapper>
    );
  });

  return contentCards;
};

const renderAboutUsOurImpact = (titleSection, cards) => {
  return (
    <AnimateIn onScroll>
      <OurImpactContainer sectionContainer>
        {renderOurImpactTitleSection(titleSection)}
        <POVWrapper>{renderContentCards(cards)}</POVWrapper>
      </OurImpactContainer>
    </AnimateIn>
  );
};

//fix when paper updated
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  padding-bottom: 0px;
  max-width: 620px;

  @media screen and (max-width: ${media.largeTop}) {
    max-width: 100%;
    width: 100%;
    gap: 24px;
    padding-bottom: 0px;
  }
`;

const ContentImage = styled.img`
  margin-bottom: 0px;
  height: 380px;
  object-fit: cover;

  @media screen and (max-width: ${media.largeTop}) {
    align-self: stretch;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  gap: 12px;

  @media screen and (max-width: ${media.hugeBottom}) {
    width: 100%;
  }
`;

const ReadMoreLink = styled(InternalLink)`
  padding-top: 8px;
  color: ${colors.linkDefault};
`;

const OurImpactContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0px;
  padding-bottom: 0px;
  gap: 40px;

  @media screen and (max-width: ${media.largeTop}) {
    align-items: flex-start;
    div {
      text-align: left;
      align-items: flex-start;
    }
  }
`;

const POVWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 40px;

  @media screen and (max-width: ${media.largeTop}) {
    flex-direction: column;
  }
`;

export default renderAboutUsOurImpact;
